exports = module.exports = require('./commonjs/read/readXlsxFileBrowser.js').default
exports['default'] = require('./commonjs/read/readXlsxFileBrowser.js').default
exports.readSheetNames = require('./commonjs/read/readSheetNamesBrowser.js').default
exports.parseExcelDate = require('./commonjs/read/parseDate.js').default
exports.Integer = require('./commonjs/types/Integer.js').default
exports.Email = require('./commonjs/types/Email.js').default
exports.URL = require('./commonjs/types/URL.js').default



//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/index.cjs
// module id = 1802
// module chunks = 2